import React from 'react'
import { Logo } from 'react-angle-dashboard-components'

import { SubNav, TopBarContainer, TopSection } from '../layouts/styles'
import { useTopBar } from '../store/selectors'
import styled from 'styled-components'
import { Paths } from '../routes/paths'

const TopBarElement = styled.div`
  width: 261px;
  display: flex;
  justify-content: center;
  align-items: baseline;
`
const FindMyDoctor = styled(TopBarElement)`
  height: 100%;
  padding: 33px 38px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--primary);
  background-color: rgb(109 57 217 / 9%);
  cursor: pointer;
`

const FindMyDoctorText = styled.span`
  text-decoration: underline;
  font-weight: 500;
`

export const TopBar = () => {
  const topbarData = useTopBar()

  return (
    <TopSection>
      <TopBarContainer>
        <TopBarElement className="text-primary">
          {topbarData?.backCallback && (
            <span
              role="button"
              className="btn text-primary d-flex align-items-center"
              onClick={topbarData.backCallback as any}
            >
              <i className="icon icon-left-arrow fs-32" />
              <span className="fs-20 d-inline-block">Back</span>
            </span>
          )}
        </TopBarElement>
        <TopBarElement>
          <Logo variant="full" color="primary" />
        </TopBarElement>
        <FindMyDoctor onClick={() => window.open(Paths.publicProviders)}>
          <i className="icon icon-specialty" style={{ fontSize: '25px' }} />
          <FindMyDoctorText className="fs-20">Find My Doctor</FindMyDoctorText>
        </FindMyDoctor>
      </TopBarContainer>
      <SubNav>
        <h2 className="fs-22 text-primary" style={{ fontFamily: 'Sentinel' }}>
          {topbarData?.completedPercentage}% Complete
        </h2>
      </SubNav>
    </TopSection>
  )
}

export default TopBar
